export default {
  userCreate: false,
  users: [],
  userInfo: null,
  globalSnackbar: { open: false, text: 'Texto' },
  globalBaseModalMessage: {
    open: false,
    type: 'primary',
    key: '',
    text: '',
  },
  toImportVideosLeft: '2',
  userPlanInfo: {},
  refreshToken: '',
  userFirstAccess: false,
  routedVideo: {},
  mainVideos: [],
  allFolders: [],
  mainFolders: [],
  deletedFolders: [],
  folderVideos: [],
  subFolderVideos: [],
  subFolder: {},
  products: {},
  onlyCustomizing: false,
  accountFolderVideos: {},
  didFetchVideos: false,
  justFewCustomizing: false,
  shouldFetchAllVideos: false,
  isTabletBreakpoint: false,
  isMobileBreakpoint: false,
  navItems: [],
  settingsNavItems: [],
  securityNavItems: [],
  fetchPermissions: false,
  userAllInfo: null,
  userPermissions: [],
  windowWidth: 0,
  drmData: {
    drmGroups: [],
    isDrmActive: false,
    loadings: {
      drmGroups: true,
    },
  },
  buyCreditsToggle: false,
  isRecapAvailable: null,
}
